import React, { useState } from 'react'
import styled from 'styled-components'
import CreationToolStatus from '../../../../types/status'
import { CreationToolUploadSource } from '../../types'
import Buttons from './buttons'
import Icon from './icon'
import Label from './label'
import StatusBar from './status-bar'

const Header = styled.div`
    align-items: center;
    display: flex;
    height: 50px;
    width: 100%;
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-width: 0; // fixes truncation issues with flexbox
    position: relative;
    width: 100%;
`

const Wrapper = styled.div`
    align-items: center;
    display: flex;
    height: 100%;
    width: 100%;
`

const Hit = styled.div`
    cursor: pointer;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`

type Props = {
    className?: string
    source: CreationToolUploadSource
    isBulk?: boolean
    isPreviewing?: boolean
    isUploading?: boolean
    setIsPreviewing: (isPreviewing: boolean) => void
}

const CreationUploadItemHeader = ({
    className,
    source,
    isBulk = false,
    isPreviewing = false,
    isUploading = false,
    setIsPreviewing,
}: Props) => {
    const [showRemoveIcon, setShowRemoveIcon] = useState<boolean>(false)
    const { error, status, uploadedId } = source

    return (
        <Header
            {...{
                className,
                onMouseOver: () => setShowRemoveIcon(true),
                onMouseOut: () => setShowRemoveIcon(false),
            }}
        >
            <Icon source={source} showRemoveIcon={showRemoveIcon} />
            <Content>
                {isBulk && <Hit onClick={() => setIsPreviewing(!isPreviewing)} />}
                <Wrapper>
                    <Label
                        source={source}
                        disabled={!!error || !!uploadedId || status !== CreationToolStatus.Idle || isUploading}
                    />
                    <Buttons
                        {...{
                            source,
                            isPreviewing,
                            onTogglePreview: setIsPreviewing,
                        }}
                    />
                </Wrapper>
                <StatusBar status={status} isError={!!error} />
            </Content>
        </Header>
    )
}

export default CreationUploadItemHeader
